/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Shalani Chethana
 * @Date 12/03/2025
 */


import React from 'react';
import { useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import contactDialogImage from '../../assets/images/product/ContactBackground.png';
import { useCreateMessageMutation } from '../../services/issueService';
import Success from './Success';
import Styles from "./contactBtnDialog.module.css";




const ContactBtnDialog = () => {

    const [open, setOpen] = useState(false);
    const [openSuccess, setOpenSuccess] = useState(false);
    const [data, setData] = useState({});
    const [createMessage] = useCreateMessageMutation();
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setData({...data , message: "Click Contact button"});
        try {
            const respond = await createMessage(data).unwrap();
            setOpen(false);
            setOpenSuccess(true)
        } catch (err) {
            console.error("Failed to save the Message: ", err);
        }
    }

    return (
        <>
            <Button variant="outlined" onClick={handleClickOpen} className={Styles.btnDialogButton}>
                Contact
            </Button>
            <Dialog
                open={open}
                onClose={handleClose}
                className={Styles.btnMainDialogComp}
                slotProps={{
                    paper: {
                        component: 'form',
                        onSubmit: (event) => {
                            event.preventDefault();
                            const formData = new FormData(event.currentTarget);
                            const formJson = Object.fromEntries(formData.entries());
                            const email = formJson.email;
                            handleClose();
                        },
                    },
                }}
            >
                <DialogTitle>Connect with us</DialogTitle>
                <DialogContent className={Styles.btnContentDialogContent}>
                    <DialogContentText>
                        <img src={contactDialogImage} className={Styles.contactDilaogImage}></img>
                        <br></br>
                        Ready to elevate your business with technology? <br></br>
                        Contact us today—call or email to schedule a consultation and explore growth opportunities!
                    </DialogContentText>
                    <TextField
                        autoFocus
                        required
                        margin="dense"
                        id="name"
                        name="email"
                        label="Email Address"
                        type="email"
                        fullWidth
                        variant="standard"
                        onChange={(e) => setData((prevData) => ({ ...prevData, email: e.target.value }))}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button type='submit' variant='contained' className={Styles.dialogSendButton} onClick={handleSubmit}> Send </Button>

                </DialogActions>
            </Dialog>

            <Success 
          open={openSuccess} 
          onClose={() => {
            setOpenSuccess(false)
            window.location.reload()
          }}
        />
        </>
    )
}

export default ContactBtnDialog;
